// WebAuthn passkey helpers — biometric registration, lock-screen unlock, and sign-in.
import { startRegistration, startAuthentication, browserSupportsWebAuthn } from "@simplewebauthn/browser";
import { api } from "./api";

export const passkeysSupported = () => browserSupportsWebAuthn();

// Local hint that a passkey was registered from this browser (per-domain UX hint only)
export const hasLocalPasskeyHint = () => localStorage.getItem("pstr_passkey") === "1";
const setLocalPasskeyHint = (v) => localStorage.setItem("pstr_passkey", v ? "1" : "0");

export async function registerPasskey() {
  const origin = window.location.origin;
  const opt = await api.post("/webauthn/register/options", { origin });
  const credential = await startRegistration({ optionsJSON: JSON.parse(opt.data.options) });
  await api.post("/webauthn/register/verify", { credential, challenge_id: opt.data.challenge_id, origin });
  setLocalPasskeyHint(true);
}

export async function unlockWithPasskey() {
  const origin = window.location.origin;
  const opt = await api.post("/webauthn/unlock/options", { origin });
  const credential = await startAuthentication({ optionsJSON: JSON.parse(opt.data.options) });
  await api.post("/webauthn/unlock/verify", { credential, challenge_id: opt.data.challenge_id, origin });
}

export async function loginWithPasskey(email) {
  const origin = window.location.origin;
  const opt = await api.post("/webauthn/login/options", { email, origin });
  const credential = await startAuthentication({ optionsJSON: JSON.parse(opt.data.options) });
  const r = await api.post("/webauthn/login/verify", { credential, challenge_id: opt.data.challenge_id, origin });
  return r.data; // { token, user }
}

export async function listPasskeys() {
  const r = await api.get(`/webauthn/credentials?origin=${encodeURIComponent(window.location.origin)}`);
  return r.data;
}

export async function deletePasskey(credentialId) {
  await api.delete(`/webauthn/credentials/${encodeURIComponent(credentialId)}`);
  setLocalPasskeyHint(false);
}
